const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId } = require('../lib/browserData');
const getZoneId = require('../lib/zoneData');
const getPoliticalId = require('../lib/politicalIdData');
const { COOKIES, DEFAULT_PRICE_GROUP, SELLER_EXPERIENCE } = require('../constants');
const constants = require('../constants');
const getPoliticalIdWithLatLong = require('../lib/politicalIdDataWithLatLong');

const SessionNotFoundError = {
  code: 'ASSOCIATE_ACCOUNT_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const CartIdNotFoundError = {
  code: 'ASSOCIATE_ACCOUNT_ERROR_CART_ID_NOT_FOUND',
  message: 'Cart ID to associate not found',
};
const AssociateAccountFailedError = {
  code: 'ASSOCIATE_ACCOUNT_ERROR_ASSOCIATION_FAILED',
  message: 'Error while associating cart to account',
};

const endpointPattern = '/s/checkout/v1/carts/{cartId}/associate-account';

async function catalystAssociateAccount(tenantId, additionalInfo = {}, catalystBaseUrl = '') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) return { cartId: undefined, errors: [SessionNotFoundError] };
  const { whitelabel = {} } = additionalInfo;

  const cartId =
    whitelabel.enabled && !whitelabel.multiSite
      ? whitelabel.cartId
      : getCookie(COOKIES.CART_ID.VALUE);
  if (!cartId) return { cartId: undefined, errors: [CartIdNotFoundError] };

  const deliveryFlow = getCookie(COOKIES.DELIVERY_FLOW);

  const baseEndpoint = endpointPattern.replace('{cartId}', cartId);

  const endpoint = deliveryFlow ? `${baseEndpoint}?deliveryFlow=${deliveryFlow}` : baseEndpoint;

  const ecommName = getEcommId(tenantId, additionalInfo);

  const isTottus = ecommName.split('-')[0] === constants.ECOMM_NAME_TOTTUS;

  const {
    politicalId: tottusPoliticalId,
    lat,
    long,
  } = isTottus ? await getPoliticalIdWithLatLong(ecommName, catalystBaseUrl) : {};
  const reqBody = {
    metadata: {
      priceGroup: DEFAULT_PRICE_GROUP,
      ...(isTottus && lat && long && { latAndLong: { lat, long } }),
    },
  };

  if (getCookie(COOKIES.SELLER_EXPERIENCE) === SELLER_EXPERIENCE.MARKETPLACE) {
    reqBody.metadata.politicalAreaId = isTottus
      ? tottusPoliticalId
      : await getPoliticalId(tenantId, catalystBaseUrl);
  } else {
    reqBody.metadata.zoneId = await getZoneId(tenantId, catalystBaseUrl);
  }
  const result = await http.post(`${catalystBaseUrl}${endpoint}`, reqBody, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': ecommName,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { cartId: undefined, errors: [AssociateAccountFailedError] };
  const { errors, data: { cart: { cartId: associatedCart } = {} } = {} } = responseBody;
  if (errors) return { cartId: undefined, errors };
  if (!associatedCart) return { cartId: undefined, errors: [AssociateAccountFailedError] };
  return { cartId: associatedCart, errors: [] };
}

module.exports = catalystAssociateAccount;
